import { Directionality } from '@angular/cdk/bidi';
import {
  Overlay,
  OverlayContainer,
  OverlayKeyboardDispatcher,
  OverlayOutsideClickDispatcher,
  OverlayPositionBuilder,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { DOCUMENT, Location } from '@angular/common';
import {
  ComponentFactoryResolver,
  Injectable,
  Injector,
  NgZone,
  Renderer2,
  RendererFactory2,
  inject,
} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DynamicOverlayContainer extends OverlayContainer {
  setContainerElement(elt: HTMLElement) {
    this._containerElement = elt;
  }
}

@Injectable({ providedIn: 'root' })
export class DynamicOverlay extends Overlay {
  private container: DynamicOverlayContainer;
  private renderer: Renderer2;

  constructor() {
    const scroll = inject(ScrollStrategyOptions);
    const overlayContainer = inject(DynamicOverlayContainer);
    const cmpFtrResolver = inject(ComponentFactoryResolver);
    const posBuilder = inject(OverlayPositionBuilder);
    const kbDispatcher = inject(OverlayKeyboardDispatcher);
    const injector = inject(Injector);
    const ngZone = inject(NgZone);
    const document = inject(DOCUMENT);
    const directionnaly = inject(Directionality);
    const location = inject(Location);
    const outsideClickDispatcher = inject(OverlayOutsideClickDispatcher);
    const rendererFactory = inject(RendererFactory2);

    super(
      scroll,
      overlayContainer,
      cmpFtrResolver,
      posBuilder,
      kbDispatcher,
      injector,
      ngZone,
      document,
      directionnaly,
      location,
      outsideClickDispatcher,
    );

    this.renderer = rendererFactory.createRenderer(null, null);
    this.container = overlayContainer;
  }

  public setContainerElement(elt: HTMLElement) {
    this.renderer.setStyle(elt, 'transform', 'translateZ(0)');
    this.container.setContainerElement(elt);
  }
}
